import { render } from "./LifeView.vue?vue&type=template&id=7f8a17ee&scoped=true"
import script from "./LifeView.vue?vue&type=script&lang=js"
export * from "./LifeView.vue?vue&type=script&lang=js"

import "./LifeView.vue?vue&type=style&index=0&id=7f8a17ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8a17ee"]])

export default __exports__